export interface BioTheme {
  name: string
  background: string
  textColor: string
  buttonBg: string
  buttonText: string
  buttonHover: string
  cardBg: string
  profileTextColor: string
  bioTextColor: string
  buttonBorder?: string
}

export const bioThemes: Record<string, BioTheme> = {
  default: {
    name: 'Default',
    background: '#ffffff',
    textColor: '#1F2937',
    buttonBg: '#4F46E5',
    buttonText: '#ffffff',
    buttonHover: '#4338CA',
    cardBg: 'rgba(255,255,255,0.8)',
    profileTextColor: '#1F2937',
    bioTextColor: '#6B7280',
  },
  minimal: {
    name: 'Minimal',
    background: '#FAFAFA',
    textColor: '#111827',
    buttonBg: '#111827',
    buttonText: '#ffffff',
    buttonHover: '#374151',
    cardBg: 'rgba(255,255,255,0.9)',
    profileTextColor: '#111827',
    bioTextColor: '#6B7280',
  },
  gradient: {
    name: 'Gradient',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    textColor: '#ffffff',
    buttonBg: 'rgba(255,255,255,0.2)',
    buttonText: '#ffffff',
    buttonHover: 'rgba(255,255,255,0.3)',
    cardBg: 'rgba(255,255,255,0.1)',
    profileTextColor: '#ffffff',
    bioTextColor: 'rgba(255,255,255,0.8)',
  },
  dark: {
    name: 'Dark',
    background: '#0f172a',
    textColor: '#f1f5f9',
    buttonBg: '#1e293b',
    buttonText: '#f1f5f9',
    buttonHover: '#334155',
    cardBg: 'rgba(30,41,59,0.8)',
    profileTextColor: '#f1f5f9',
    bioTextColor: '#94a3b8',
  },
  neon: {
    name: 'Neon',
    background: '#0a0a0a',
    textColor: '#00ff88',
    buttonBg: 'transparent',
    buttonText: '#00ff88',
    buttonHover: 'rgba(0,255,136,0.1)',
    cardBg: 'rgba(0,255,136,0.05)',
    profileTextColor: '#00ff88',
    bioTextColor: 'rgba(0,255,136,0.7)',
    buttonBorder: '#00ff88',
  },
  pastel: {
    name: 'Pastel',
    background: 'linear-gradient(180deg, #fce4ec 0%, #e8eaf6 50%, #e0f7fa 100%)',
    textColor: '#5c6bc0',
    buttonBg: '#ffffff',
    buttonText: '#5c6bc0',
    buttonHover: '#f5f5f5',
    cardBg: 'rgba(255,255,255,0.7)',
    profileTextColor: '#5c6bc0',
    bioTextColor: '#7986cb',
  },
}

export const themeKeys = Object.keys(bioThemes) as Array<keyof typeof bioThemes>
